import React, { useState, useEffect } from "react";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { useLocation, useNavigate } from "react-router-dom";
import Cliam from "./Cliam";
import ClaimSuccess from "./Digital_Details";
import Auth from "../Auth_Remeed/container";
import { toast } from "react-toastify";
import { set } from "date-fns";

const AuthConsider = () => {

  const { makeApiRequest } = useApiRequest();
  const [loader, setLoader] = useState(false);
  const [digitalorderData, setDigitalOrderData] = useState([]);
  const [claimedFlag, setClaimFlag] = useState(false);
  const [claimedItem, setClaimedItem] = useState(null);
  const [claimResponseData, setClaimResponseData] = useState(null);
  const [loginFlag, setLoginFlag] = useState(false);


  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const isClaimed = params.get("claim") === "true";
  const lineitemid = params.get("lineitemid");
  const digital_orderId = params.get("value");

  const [orderId, setOrderId] = useState(digital_orderId);
console.log(digital_orderId); // E969040105F94F66

  useEffect(() => {
    DigitalOrders();

    if (isClaimed && lineitemid) {
      handleClaimFromUrl(lineitemid);
    }
  }, [isClaimed, lineitemid]);

  /* ---------------------------------- */
  /* 🔹 FETCH DIGITAL ORDERS */
  /* ---------------------------------- */
  const DigitalOrders = () => {
    setLoader(true);

    const UserJWTAuth = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v1/digital/order/${orderId}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: (res) => {
        setLoader(false);
        const data = res?.data?.data || [];
        setDigitalOrderData(data);
      },
      handleError: (error ) => {
         console.log("Error fetching digital orders:", error.response.data.status.code);
         if(error.response.data.status.code === "UNAUTHORIZED"){
setLoginFlag(true);
setLoader(false);
         }

                  if(error.response.data.status.code === "ACCESS_DENIED"){
setLoginFlag(true);
setLoader(false);

         }
        
        console.log("Failed to fetch digital orders:", error.response.data.status.code);
         if(error.response.data.status.code === "BAD_REQUEST"){

          setLoginFlag(false)
          setLoader(false);
          toast.error(error?.response?.data?.status?.message || "Failed to fetch digital orders"  );
         }
        //
       
        
        
      },
    });
  };

  /* ---------------------------------- */
  /* 🔹 HISTORY DIGITAL ORDER (for claimed items) */
  /* ---------------------------------- */
  const HistorydigitalOrder = (digitalLineItemClaimId, itemData) => {
    if (!digitalLineItemClaimId) {
      navigate(`/digital_details?digitalLineItemClaimId=${digitalLineItemClaimId}&orderId=${digital_orderId}`);
      return;
    }

  
  };

  /* ---------------------------------- */
  /* 🔹 CLAIM DIGITAL ORDER */
  /* ---------------------------------- */
      const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

const Claim= (digitalLineItemClaimId) => {
 

  makeApiRequest({
    url: `${import.meta.env.VITE_API_BASE_URL}/digital/claim`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId || "",
    },
    data: {
    
  "digitalLineItemId":digitalLineItemClaimId,

    },
    handleSuccess: (res) => {
      console.log("Verified:", res);
      //alert("Verified ✅");
     
      navigate(`/digital_details?digitalLineItemClaimId=${digitalLineItemClaimId}&orderId=${digital_orderId}`);
    },
    handleError: (err) => {
      console.log("Error:", err);
       toast.error("Invalid OTP ❌");
      //alert("Invalid OTP ❌");
      
    },
  });
};
  const ClaimdigitalOrder = (digitalLineItemClaimId, itemData) => {
    console.log("ClaimdigitalOrder", digitalLineItemClaimId, itemData);


    if (digitalLineItemClaimId) {
    Claim(digitalLineItemClaimId);
      return;
    }

  };

  const handleClaimFromUrl = (lineitemId) => {
    const item = digitalorderData.find(
      (item) => item.digitalLineItemList?.some(list => list.digitalLineItemClaimId === parseInt(lineitemId))
    );
    if (item) {
      setClaimedItem(item);
      setClaimFlag(true);
    }
  };

  if (loader) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (claimedFlag && claimedItem) {
    return <ClaimSuccess 
      claimedItem={claimedItem} 
      claimResponse={claimResponseData}
      orderId={orderId}
    />;
  }

  return (
    <>
    {
      loginFlag ? (
        <Auth/>
       
      ) : (       
    <Cliam
      digitalorderData={digitalorderData}
      ClaimdigitalOrder={ClaimdigitalOrder}
      HistorydigitalOrder={HistorydigitalOrder}
      orderId={orderId}
    />)
  }
  </>
  );
};

export default AuthConsider;